export default {
  URL: `${window.location.protocol}//${window.location.host}`,
  URL_IMAGES: `${window.location.protocol}//${window.location.host}/images`,
};
